import { useDocumentHead } from '@/hooks/use-document-head'

export function DocumentHeadManager() {
  useDocumentHead({
    title: 'Super AI',
    description: 'Your AI-powered real estate communication platform',
    favicon: true,
  })

  return null
}
